import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-32 md:pt-40">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
